enum ProductType {
  Original = 1,
  WGuarnicion = 2,
  WExtra = 3,
  Extra = 4,
  Guarnicion = 5,
}

export default ProductType;
